module.exports = __webpack_public_path__ + "assets/img/eagle-one-prima.90bf9bae.jpg";